import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {GAME_CENTER_HEADER_MODULE} from "../game-center-header-module.consts";
import {GameCenterHeaderModuleState} from "../models/game-center-header-module.state";
import {FullGameFetchHandler} from "../../../../../core/handlers/full-game.fetch-handler";
import {ACTION_TYPES, COMPONENT_STATES} from "../../../../../core/consts";
import {DescriptionHeaderGameViewModel} from "../../../../../core/components/description-header/models/description-header.game.view-model";

export class GameCenterHeaderModuleFetchHandler extends FullGameFetchHandler {
  controller: GameCenterHeaderModuleController;
  state: GameCenterHeaderModuleState;

  populateDelta(dataSource, params) {
    this.controller.action(ACTION_TYPES.populateData, {dataSource});

    this.state.createAnimation(dataSource.game.animation);
  }

  async action() {
    await super.action();

    await this.controller.action(GAME_CENTER_HEADER_MODULE.ACTION_TYPES.countdown, {shouldStart: true});
    await this.controller.action(GAME_CENTER_HEADER_MODULE.ACTION_TYPES.changeDescriptionEntity, {
      entity: new DescriptionHeaderGameViewModel(this.state.dataSource?.game, this.state.headerTitle, this.state.headerDescription)
    });
  }

  async onDidUpdate(prevProps, nextProps) {
    const matchupIdChanged: Boolean = prevProps.matchupId !== nextProps.matchupId;
    const gameIdChanged: Boolean = nextProps.gameId !== prevProps.gameId;

    if (gameIdChanged || matchupIdChanged) {
      this.controller.store.setComponentState(COMPONENT_STATES.loading);
      await this.controller.action(GAME_CENTER_HEADER_MODULE.ACTION_TYPES.countdown, {shouldStart: false});
      // await this.controller.action(ACTION_TYPES.populateData, nextProps.location?.state);
      this.state.countdownText = null;
      await this.controller.action(GAME_CENTER_HEADER_MODULE.ACTION_TYPES.changeDescriptionEntity);
      await this.action();
    }
  }
}
